<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('advanced_fulfillment_supplied.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right white_highlight--text tools-view-height mx-1" color="secondary" @click="modalMarkAsSent = true; ordersType = 'track'; barcode = '';" style="max-width: 40px !important; min-width: 40px !important" >
                                <v-icon class="material-icons-outlined" small>local_shipping</v-icon>
                            </v-btn>
                        </template>

                        <span>{{ $t('fulfillment_eon_in_process.mark_as_sent') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right white_highlight--text tools-view-height mx-1" color="secondary" @click="downloadOrdersSummary" style="max-width: 40px !important; min-width: 40px !important" >
                                <v-icon class="material-icons-outlined" small>downloading</v-icon>
                            </v-btn>
                        </template>

                        <span>{{$t('advanced_fulfillment_supplied.download_orders_summary')}}</span>
                    </v-tooltip>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable show-select v-model="selected" :pagination="[15, 25, 50, 100]" :props="{headers:headers, items: props.items, search:props.search}" :itemsLength="props.meta.total" :options.sync="pagination.pendings" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            </v-container>     
            <v-dialog v-model="modalRestore" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h3 class="text-uppercase">
                                {{ $t('fulfillments_cod_in_process.restore_modal.restore') }}
                            </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-3 my-3 text-center">
                            <v-col cols="12">
                                <h5>{{ $t('fulfillments_cod_in_process.restore_modal.message') }}</h5>
                            </v-col>
                        </v-row>
                        
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalRestore = false">{{ $t('fulfillments_cod_in_process.no') }}</v-btn>
                            <v-btn color="error" @click="restoreOrder">
                                {{ $t('fulfillments_cod_in_process.yes_restore') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalDetail" persistent max-width="90%" v-if="orderToShow != null">
                <v-card style="min-width: 700px !important">
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h4 class="text-uppercase blue_accent--text py-2">
                                {{ $t('fulfillments_cod_pendings.order_details.header') }} {{ this.orderToShow.uniqueOrderNumber }}
                            </h4>
                        </v-row>
                    </v-card-title>
                    
                    <div class="marker1-1" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_cod_pendings.details') }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.order_number") }}</label> <label>{{ this.orderToShow.uniqueOrderNumber }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.date") }}</label> <label>{{ this.orderToShow.createdAt }}</label></div>
                    <div class="detail_content1" v-if="shipping_service != 'otra'"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.shippingService }}</label></div>
                    <div class="detail_content1" v-if="shipping_service == 'otra'"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.shipping_service") }}</label> <label>{{ this.orderToShow.externalShippingService }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.invoice") }}</label> <label>{{ this.orderToShow.invoice }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.client != null"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.client") }}</label> <label>{{ this.orderToShow.client.name }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.cod") }}</label> <label>{{ this.orderToShow.total }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.buyer") }}</label> <label>{{ this.orderToShow.consignee.name }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.state") }}</label> <label>{{ this.orderToShow.consignee.state }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.municipality") }}</label> <label>{{ this.orderToShow.consignee.municipality }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.neighborhood") }}</label> <label>{{ this.orderToShow.consignee.neighborhood }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_prepaid_pendings.address") }}</label> <label>{{ this.orderToShow.consignee.street }} {{ this.orderToShow.consignee.externalNumber }} {{ this.orderToShow.consignee.internalNumber }}</label></div>
                    <div class="detail_content1" v-if="orderToShow.consignee != null"><label style="font-weight:bold">{{ $t("fulfillments_cod_pendings.zip_code") }}</label> <label>{{ this.orderToShow.consignee.zipcode }}</label></div>
                    
                    <div class="marker1-1 mt-2" style="font-weight:bold"><label class="mx-1">{{ $t('fulfillments_cod_pendings.products') }}</label></div>
                    <span v-if="orderToShow.shipmentProductDetail != null">
                        <div v-for="(product, i) of orderToShow.shipmentProductDetail.data" :key="i" class="detail_content1"><label style="font-weight:bold">{{ product.attributes.product.sku }}</label> <label>{{ product.attributes.quantity }}</label></div>
                    </span>
                    <span v-if="orderToShow.products != null">
                        <div v-for="(product, i) of orderToShow.products" :key="i" class="detail_content1"><label style="font-weight:bold">{{ product.sku }}</label> <label>{{ product.quantity }}</label></div>
                    </span>

                    <v-card-text class="mt-5">
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalDetail = false">{{ $t('fulfillments_cod_pendings.go_back') }}</v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>

            <v-dialog v-model="modalMarkAsSent" persistent max-width="90%">
                <v-card style="min-width: 800px !important">
                    <v-card-text>
                        <v-row align="center" justify="center" class="pt-3 mt-3 text-center">
                            <v-col cols="12">
                                <h3>{{ $t('fulfillment_eon_in_process.mark_orders_as_update') }}</h3>
                            </v-col>
                        </v-row>
                        <br>
                        <span v-if="!showOrdersUpdatedResults" class="my-0 py-0">
                            <v-row class="py-0 my-0" justify="center" align="start">
                                <v-col cols="10" class="my-0 py-0">
                                    <v-radio-group v-model="ordersType" class="my-0 py-0">
                                        <v-row class="py-0 my-0" justify="start" align="start">
                                            <v-col cols="4" class="py-0">
                                                <v-radio class="mt-0" color="blue_accent" :label="$t('fulfillment_eon_in_process.track')" :value="'track'"></v-radio>
                                            </v-col>                                    
                                            <v-col cols="4" class="py-0">
                                                <v-radio class="mt-0" color="blue_accent" :label="$t('fulfillment_eon_in_process.tracking_number')" :value="'tracking_number'"></v-radio>
                                            </v-col>   
                                            <v-col cols="4" class="py-0">
                                                <v-radio class="mt-0" color="blue_accent" :label="$t('fulfillment_eon_in_process.order_number')" :value="'unique_order_number'"></v-radio>
                                            </v-col>                                 
                                        </v-row>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row class="py-0 my-0" justify="center" align="start">
                                <v-col cols="10" class="my-0 py-0">
                                    <v-radio-group v-model="uploadOrdersType" class="my-0 py-0">
                                        <v-row class="py-0 my-0" justify="start" align="start">
                                            <v-col cols="6" class="py-0">
                                                <v-radio class="mt-0" color="blue_accent" :label="$t('fulfillment_eon_in_process.scann')" :value="'scann'"></v-radio>
                                            </v-col>                                    
                                            <v-col cols="6" class="py-0">
                                                <v-radio class="mt-0" color="blue_accent" :label="$t('fulfillment_eon_in_process.csv')" :value="'csv'"></v-radio>
                                            </v-col>                                 
                                        </v-row>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row class="py-0 my-0" justify="center" align="center">
                                <v-col cols="10">
                                    <label for="">{{ $t('fulfillment_eon_in_process.mark_as_sent_note_1') }} {{ ordersToUpdate.length - 1 }} {{ $t('fulfillment_eon_in_process.mark_as_sent_note_2') }}</label>
                                </v-col>
                            </v-row>
                            <span v-if="uploadOrdersType == 'scann'">
                                <span v-for="value of ordersLimit" :key="value" > 
                                    <v-row class="py-0 my-0" justify="center" align="center" v-if="ordersToUpdate.length > value - 1">                            
                                        <v-col cols="9" class="py-0 my-0">
                                            <v-text-field class="py-0" v-model="ordersToUpdate[value - 1]" readonly :label="$t('fulfillment_eon_in_process.track')"></v-text-field>
                                        </v-col>
                                        <v-col cols="1">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" class="right tools-view-height mx-1" outlined color="error" style="max-width: 30px !important; min-width: 30px !important" @click="removeData(value - 1)">
                                                        <v-icon class="px-1" small>close</v-icon>
                                                    </v-btn>
                                                </template>

                                                <span>{{ $t('fulfillment_eon_in_process.remove') }}</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>                            
                                </span>
                            </span>

                            <span v-if="uploadOrdersType == 'csv'">
                                <v-row class="py-0 my-0" justify="center" align="center">                            
                                    <v-col cols="8" class="py-0 my-0">
                                        <v-file-input prepend-icon="" append-outer-icon="cloud_upload" class="cloud_upload py-0" multiple :clearable="true" v-model="csvFile" accept="csv" :label="$t('fulfillment_eon_in_process.load_file')"></v-file-input>
                                    </v-col>
                                    <v-col cols="2" class="py-0 my-0">
                                        <v-btn class="mx-3" text @click="loadOrdersFromCsv()">{{ $t('fulfillments_prepaid_returns.load') }}</v-btn>
                                    </v-col>
                                </v-row>        
                                
                                <span v-for="(value, index) of ordersToUpdate" :key="index" > 
                                    <v-row class="py-0 my-0" justify="center" align="center" v-if="ordersToUpdate.length > 0">                            
                                        <v-col cols="9" class="py-0 my-0">
                                            <v-text-field class="py-0" v-model="ordersToUpdate[index]" readonly :label="$t('fulfillment_eon_in_process.track')"></v-text-field>
                                        </v-col>
                                        <v-col cols="1">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn v-on="on" class="right tools-view-height mx-1" outlined color="error" style="max-width: 30px !important; min-width: 30px !important" @click="removeData(index)">
                                                        <v-icon class="px-1" small>close</v-icon>
                                                    </v-btn>
                                                </template>

                                                <span>{{ $t('fulfillment_eon_in_process.remove') }}</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>                            
                                </span>
                            </span>
                            
                            <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                <v-col cols="11" class="py-0 my-0 mx-0 px-0" align="end" justify="end">
                                    <v-btn class="mx-3" text @click="closeModalOrdersToMarkAsSent()">{{ $t('fulfillments_prepaid_returns.cancel') }}</v-btn>
                                    <v-btn color="secondary" class="white_highlight--text" @click="makeUpdateOrders()" :disabled="uploadOrdersType == 'csv' && !canSave">
                                        {{ $t('fulfillment_eon_in_process.save') }}
                                    </v-btn>    
                                </v-col>
                            </v-row>
                        </span>

                        <span v-if="showOrdersUpdatedResults">
                            <v-row class="py-0 my-0" justify="center" align="start">
                                <v-col cols="10">
                                    <h5>{{ $t('fulfillment_eon_in_process.mark_as_sent_note_1')}} {{ ordersToUpdate.length }} {{ $t('fulfillment_eon_in_process.mark_as_sent_note_2') }} </h5>
                                </v-col>
                            </v-row>

                            <v-row class="py-0 my-0" justify="center" align="start">
                                <v-col cols="10">
                                    <datatable class="custom_table_class" :hide_pagination="true" :props="{headers:headersMarkedAsSent, items: ordersUpdatedResults}" @methodHandler="methodHandler"></datatable>
                                </v-col>
                            </v-row>
                            
                            <v-row class="px-0 py-0 my-0" justify="center" align="center">
                                <v-col cols="11" class="py-0 my-0 mx-0 px-0" align="end" justify="end">
                                    <v-btn color="secondary" class="white_highlight--text" @click="closeModalOrdersToMarkAsSent()">
                                        {{ $t('fulfillment_eon_in_process.close') }}
                                    </v-btn>    
                                </v-col>
                            </v-row>
                        </span>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>

            <v-dialog v-model="modalAlreadyOpen" persistent max-width="50%">
                <v-card>
                    <v-row align="center" justify="center" class="text-center py-8 px-10">
                        <v-col cols="12">
                            <h3>{{ $t('fulfillments_cod_pendings.multiple_fulfillment_tabs') }}</h3>
                        </v-col>
                    </v-row>
                    <div class="marker"></div>
                </v-card>
            </v-dialog>

        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>
import FileSaver from 'file-saver';
import { HttpExternalShipmentRepository } from '../../infrastructure/external_shipment_repository';
import { affExternalShipmentsUseCase } from '../../application/use_cases/aff_external_shipments_index_use_case';

export default {
    computed: {
        headers(){
            return [
                { text: this.$t('advanced_fulfillment_supplied.order'), align: "center", value: 'unique_order_number', class: 'text-uppercase' },
                { text: this.$t('advanced_fulfillment_supplied.shipment_number'), align: "center", value: 'tracking_number', class: 'text-uppercase' },
                { text: this.$t('advanced_fulfillment_supplied.customer'), align: "center", value: 'client.name', class: 'text-uppercase' },
                { text: this.$t('advanced_fulfillment_supplied.date'), align: "center", value: 'date', class: 'text-uppercase' },
                { text: this.$t('advanced_fulfillment_supplied.value'), align: "center", value: 'total', class: 'text-uppercase' },
                { text: this.$t('advanced_fulfillment_supplied.actions'), align: "center", value: 'actions', class: 'text-uppercase', sortable: false },
            ];
        },
        headersMarkedAsSent(){
            return [
                { text: this.$t('fulfillment_eon_in_process.message'), value: 'message' },
            ];
        },
    },
    data(){
        return {
            shipping_service: this.$route.params.shipping_service,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            modalDelete: false,
            modalDetail: false,
            modalRestore: false,
            modalMarkAsSent: false,
            modalAlreadyOpen: false,
            ordersToUpdate: [""],
            ordersUpdatedResults: [],
            showOrdersUpdatedResults: false,
            ordersType: "track",
            uploadOrdersType: "scann",
            ordersLimit: 1,
            csvFile: [],
            readFile: '',
            readRows: [],


            orderToShow: "",
            orderToRestore: "",
            props: {
                search: '',
                items: [],
                meta: {
                    total: 0,
                    total_pages: 0,
                    per_page: 15,
                    page: 1
                },
                sort_by: [],
            },
            selected: [],
            controller_name: "advanced_fulfillment",
            pagination: {page: 1, itemsPerPage: 15, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false}

        }
    },
    async mounted(){
        await this.checkIfCanOpen();        

        let self = this; 
        const leaveHandler = (e) => { 
            e.preventDefault();
            e.returnValue = '';
        };

        const keyPressHandler = (e) => {
            if(self.last == true && /^\S+$/.test(e.key)) { 
                self.barcode = e.key;
                self.last = false;
            }
            else if(e.code == "Enter") {
                self.last = true;
                self.updateList();
            }
            else if(/^\S+$/.test(e.key)) {
                self.barcode += e.key;
            }
        };

        window.addEventListener('beforeunload', leaveHandler, { capture: true });
        window.addEventListener ('keypress', keyPressHandler, { capture: true });
        
        this.$once('hook:beforeDestroy',
            () => window.removeEventListener('beforeunload', leaveHandler)
        );
        this.$once('hook:beforeDestroy',
            () => window.removeEventListener('keypress', keyPressHandler)
        );


        this.$store.state.module = "headers.advanced_fulfillment_eon_supplied";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){

            this.props.items = [];
            
            try {
                const response = await affExternalShipmentsUseCase("supplied_orders", this.props.meta.page, this.props.meta.per_page, this.props.search, this.props.sort_by, HttpExternalShipmentRepository);

                this.props.items = response.data.data;
                this.props.meta = response.data.meta;
            }
            catch(e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data
                }
            }
        },
        downloadOrdersSummary: async function(){
            if(this.selected.length <= 0) return;
            this.$store.state.loaderProps.visible = true;

            var shipments_ids = "";
            this.selected.forEach(image => {
                shipments_ids += image.id + ","; 
            })
            shipments_ids = shipments_ids.substring(0, shipments_ids.length - 1);

            const ordersSummary = await this.getOrdersSummary(shipments_ids);
            await FileSaver.saveAs(ordersSummary.data, "Orders_Summary.pdf");

            this.$store.state.loaderProps.visible = false;
        },
        getOrdersSummary: async function(ids){
            const lsToken = localStorage.getItem("access_token");

            const file = await this.$http.get(this.$store.state.chronosApi + 'external_shipment/order_summary/' + ids, {headers: {Authorization: lsToken}, responseType:'blob'});
            return file;
        },
        showDetails(order){
            this.orderToShow = order;
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
 
            this.$http.get(this.$store.state.chronosApi + 'external_shipment/get_info/' + order, {headers: {Authorization: lsToken}})
            .then((response) => {
                this.orderToShow = {
                    uniqueOrderNumber: response.data.order.unique_order_number,
                    createdAt: response.data.order.created_at.substring(0,10),
                    shippingService: response.data.order.shipping_service,
                    customer: response.data.order.name,
                    buyer: response.data.order.consignee_name,
                    products: JSON.parse(response.data.order.products).products
                }
                this.$store.state.loaderProps.visible = false;
                this.modalDetail = true;
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            })
        },
        askRestore(order){
            this.modalRestore = true;
            this.orderToRestore = order;
        },
        restoreOrder(){
            this.$store.state.loaderProps.visible = true;
            if(this.orderToRestore != ''){
                const lsToken = localStorage.getItem("access_token");
                this.$http.put(this.$store.state.chronosApi + 'external_shipment/restore/' + this.orderToRestore, {headers: {Authorization: lsToken}})
                .then((response) => {
                    if(response.status === 200) {
                        this.orderToRestore = '';
                        this.modalRestore = false;
                        this.snackbar = {
                            visible: true,
                            color: 'success2',
                            text: this.$t('fulfillments_cod_sent.restored')
                        }
                        this.index();
                    }
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.$store.state.loaderProps.visible = false;
                })
            }
            else{
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: "error"
                }
            }
        },
        removeData(index){
            this.ordersToUpdate.splice(index, 1)
            if(this.ordersToUpdate.length > 1) this.ordersLimit -= 1;

            console.log(this.ordersToUpdate);
        },
        closeModalOrdersToMarkAsSent(){
            this.ordersToUpdate = [""];
            this.ordersLimit = 1;
            this.modalMarkAsSent = false;
            this.showOrdersUpdatedResults = false;
            this.csvFile = [];
            this.ordersUpdatedResults = [];
            this.barcode = "";
            this.ordersType = "track";
            this.uploadOrdersType = "scann";
            this.readFile = '';
            this.readRows = [];
            this.canSave = false;

            this.index();    
        },
        updateList(){
            this.barcode = this.barcode.toString().replaceAll("Enter", "");
            this.ordersToUpdate[this.ordersToUpdate.length - 1] = this.barcode;

            this.ordersLimit++;
            this.ordersToUpdate.push("");
            this.barcode = "";
        },
        async makeUpdateOrders(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");

            if(this.ordersToUpdate[this.ordersToUpdate.length - 1] == "") this.ordersToUpdate.pop();
            if(this.ordersToUpdate.length == 0) return;

            this.$http.post(this.$store.state.chronosApi + 'external_shipment/mark-as-sent', { orders: this.ordersToUpdate, type: this.ordersType }, {headers: {Authorization: lsToken}})
            .then((response) => {
                this.showOrdersUpdatedResults = true;
                this.ordersUpdatedResults = response.data.map(x => {
                    return { message: x?.success?.message ?? x?.fault?.message }
                })
                this.$store.state.loaderProps.visible = false;
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
                this.ordersToUpdate = [""];
                this.ordersLimit = 1;
            })
        },
        async loadOrdersFromCsv(){
            if(this.csvFile.length > 0){
                this.createInput(this.csvFile[0]);
                this.canSave = true;
            }
        },
        createInput(file) {
            const promise = new Promise((resolve) => {
                const reader = new FileReader();
                // const vm = this;
                reader.onload = () => {
                    resolve((this.readFile = reader.result));
                };
                reader.readAsText(file);
            });

            promise.then(
                result => {
                    /* handle a successful result */
                    this.readRows = result.split('\r\n');
                    this.sTHeaders = this.readRows[0].split(',');
                    this.readRows.shift();
                    this.ordersToUpdate = [];         
                    this.readRows.forEach((x) => {
                        const num = x.split(',')
                        this.ordersToUpdate.push(num[0]);
                    })
                },
                error => {
                    /* handle an error */ 
                    console.log(error);
                }
            );
        },
        async downloadLabelExt(order) {
            this.$store.state.loaderProps.visible = true;
            // var zip = new JSZip();
            const lsToken = localStorage.getItem("access_token");
            const response = await this.$http.get(this.$store.state.chronosApi + 'external_shipment/get_labels_urls/' + order, {headers: {Authorization: lsToken}})
            var urls = ""
            
            if(typeof response.data.data == "string") urls = JSON.parse(response.data.data);
            else urls = response.data.data

            for(var i = 0; i < urls.length; i++){
                const file = await this.getLabelFile(order, urls[i].index ?? 0, lsToken)

                if(file.data.code == 200) {
                    FileSaver.saveAs(file.data.success.arguments.file, file.data.success.arguments.filename);
                }
                else {
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: this.$t('fulfillment_eon_in_process.download_label_error') + (i + 1)
                    };
                }
            }

            this.$store.state.loaderProps.visible = false;
        },
        getLabelFile: async function (id, index, lsToken){
            const file = await this.$http.get(this.$store.state.chronosApi + 'external_shipment/download_label/' + id + '/' + index, {headers: {Authorization: lsToken}})
            return file
        },
        getLabelFiles: async function(url, type, name){
            const lsToken = localStorage.getItem("access_token");
            if(type == 'label'){
                const blob = await this.$http.get(url, {headers: {Authorization: lsToken}, responseType:'blob' });
                return {response: blob, name: name + '-A.png'};
            } 
            else if(type == 'attached_file'){
                const blob = await this.$http.get(url.url, {headers: {Authorization: lsToken}, responseType:'blob' });
                return {response: blob, name: name + ".pdf"};
            } 
        },
        async handleSelected(value){
            this.selected = value;
        },
        async onOptionsChange(options) {
            this.props.meta.page = options.page;
            this.props.meta.per_page = options.itemsPerPage;
            
            if(options.sortBy.length > 0){
                this.props.meta.page = 1;
                this.props.sort_by = [{field: options.sortBy[0], direction: options.sortDesc[0] ? 'desc' : 'asc'}];
            } 
            else if(options.sortBy.length != this.props.sort_by.length) {
                this.props.meta.page = 1;
                this.props.sort_by = [];
            } 
            
            if(this.shipping_service == "eon") this.controller_name = "advanced_external_fulfillment";
            else this.controller_name = "advanced_fulfillment"

            this.index();
        },
        checkIfCanOpen(){
            localStorage.open_pages = Date.now();
            window.addEventListener('storage', (e) => {
                if(e.key == "open_pages") localStorage.setItem("a_fulfillment_eon", Date.now())
                if(e.key == "a_fulfillment_eon") this.modalAlreadyOpen = true;              
            }, false);
        },
    },
    watch:{
        '$route.params.shipping_service': function() {
            location.reload();
        },
        'props.search': function() {
            clearTimeout(this.debounceTimer)
            
            this.debounceTimer = setTimeout(() => {
                this.props.meta.page = 1;
                this.index();
            }, 800);
        }
    }
}
</script>

<style>

</style>